import { createContext, useContext, type ReactNode } from 'react';

export interface CommandPaletteContextValue {
  open: () => void;
}

const CommandPaletteContext = createContext<CommandPaletteContextValue | null>(null);

/**
 * queue #680 §R680-4 — `AuthLayout` 이 소유한 단일 `useCommandPalette` 인스턴스의 `open` 을
 * 하위 트리(예: `NotFoundPage` 의 "통합검색 열기" 버튼)에 내려준다. 두 번째 팔레트 인스턴스를
 * 만들지 않고 기존 전역 팔레트를 재사용하기 위한 배선용 context.
 */
export function CommandPaletteProvider({
  value,
  children,
}: {
  value: CommandPaletteContextValue;
  children: ReactNode;
}) {
  return <CommandPaletteContext.Provider value={value}>{children}</CommandPaletteContext.Provider>;
}

/**
 * Provider 부재(예: `NotFoundPage` 단독 렌더 테스트)에서는 `null` 을 반환한다 — 소비 측은
 * Ctrl+K keydown 디스패치로 fallback 한다(§R680-4).
 */
export function useCommandPaletteContext(): CommandPaletteContextValue | null {
  return useContext(CommandPaletteContext);
}
